import LoadingWheel from "./LoadingWheel";

export function FullscreenLoading() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gray-50">
      <LoadingWheel />
    </div>
  );
}
